import { useState } from "react";

export const useFirstRenderDate = () => {
    const [firstRenderDate] = useState(new Date());
    return firstRenderDate;
};
